import { Star, X, Home } from "lucide-react";

const keyOf = (l) => `${l.lat.toFixed(2)},${l.lon.toFixed(2)}`;

export const FavoritesBar = ({ favorites, activeKey, homeKey, home, onSelect, onRemove }) => {
  const list = [...(favorites || [])];
  if (home && !list.some((f) => keyOf(f) === homeKey)) list.unshift({ ...home, __homeOnly: true });
  if (list.length === 0) return null;
  return (
    <div className="flex items-center gap-2 overflow-x-auto no-scrollbar pb-1" data-testid="favorites-bar">
      <div className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-muted-foreground shrink-0 pr-1">
        <Star className="w-3.5 h-3.5 text-amber-400 fill-amber-400" />
        Favorit
      </div>
      {list.map((f) => {
        const key = keyOf(f);
        const active = key === activeKey;
        const isHome = key === homeKey;
        return (
          <div
            key={key}
            data-testid={`favorite-chip-${f.name}`}
            className={`group flex items-center gap-2 rounded-full pl-3 pr-2 py-1.5 shrink-0 cursor-pointer border transition-colors ${
              active
                ? "bg-primary text-primary-foreground border-primary"
                : "glass hover:border-primary/40"
            }`}
            onClick={() => onSelect(f)}
          >
            {isHome && <Home className="w-3.5 h-3.5" data-testid={`home-icon-${f.name}`} />}
            <span className="text-sm font-medium">{f.name}</span>
            {!f.__homeOnly && (
              <button
                data-testid={`remove-favorite-${f.name}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove(f);
                }}
                className="opacity-50 group-hover:opacity-100 transition-opacity"
              >
                <X className="w-3.5 h-3.5" />
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};
